// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if ({ "index":1,"lib-polyfill":1,"lib-react":1,"lib-router":1,"vendors-node_modules_react-laag_dist_react-laag_esm_js-node_modules_rsbuild_core_dist_client_-d7d115":1 }[chunkId]) return "static/js/" + chunkId + ".js";
  // return url for filenames based on template
  return "static/js/async/" + chunkId + ".js"
}